import { render, staticRenderFns } from "./AddNewTool.vue?vue&type=template&id=2a08880c&scoped=true&"
import script from "./AddNewTool.vue?vue&type=script&lang=js&"
export * from "./AddNewTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08880c",
  null
  
)

export default component.exports